import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Tooltip,
  Typography,
  Snackbar,
  Alert,
  CircularProgress
} from "@mui/material";
import ToggleButtonComponent from "../../../shared/Dashboard/ToogleButton";
import TabComponent from "./TabComponent";
import { InfoOutlined } from "@mui/icons-material";
import axiosInstance from "../../../utils/axios";
import { getView } from "../../../shared/Helper";
import { fetchChecklistData, fetchTypeData } from "../../../atoms/setup/SetupAtoms";
import { useAtom } from "jotai";
import IndividualTrackerRow from "./IndividualTrackerRow";
import IndividualZimmerBlock from "./ZimmermanTrackerRow";
// import IndividualZimmerBlock from "./ZimmermanTrackerRow";
import { startCase, toLower } from 'lodash';
import { getCurrentTerms } from "../../../shared/projectTypeUtils";
import { isReadOnly } from "../../../utils/permissionUtils";

const ParentComponent = (props) => {
  const {
    isEdit,
    setIsEdit,
    view,
    setView,
    active,
    customFields,
    setCustomFields,
    setCheckpoints,
    checkpoints,
    value,
    setValue,
    listData,
    loading,
    data,
    tabLoader,
    selectedTt,
    setSelectedTt,
    selectedPier,
    setSelectedPier,
    checklistView,
    setChecklistView,
  currentProject} = props;
  const { SvgData, pierLegends } = data;
  const [loader, setLoader] = useState(false);
  const [, setChecklist] = useAtom(fetchChecklistData);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [btnLoader, setButtonLoader] = useState(false);
  const [saveBtnLoader, setSaveBtnLoader] = useState(false);
  const [, setType] = useAtom(fetchTypeData);
  const [errors, setErrors] = useState({ customFields: {}, checkpoints: {} });
  const TERMS = getCurrentTerms()



  const validateFields = () => {
    const view = getView(value);

    const fieldErrors = (customFields?.[view] || [])
      .filter(field => !field.delete) 
      .map(field => ({
        name: !field.name,
        type: field.type === ""
      }));

    const checkpointErrors = (checkpoints?.[view] || [])
      .filter(c => !c.delete) 
      .map(c => ({
        name: !c.name,
        acceptance_criteria: !c.acceptance_criteria,
        inspection_type: !c.inspection_type
      }));

    const hasErrors =
      fieldErrors.some(err => Object.values(err).includes(true)) ||
      checkpointErrors.some(err => Object.values(err).includes(true));

    setErrors({
      customFields: { [view]: fieldErrors },
      checkpoints: { [view]: checkpointErrors }
    });

    return !hasErrors;
  };

  const handleSave = async () => {
    const isValid = validateFields();
    const views = getView(value);

    if (!isValid) {
      return;
    }

    setLoader(true);

    const result = {};
    result["checkpoints"] = checkpoints?.[views];
    result["custom_inputs"] = customFields?.[views];
    result["name"] = "";

    if (listData?.[views]?.id) {
      result["id"] = listData?.[views]?.id;
    }

    const updatedData = {
      ...result,
    };

    try {
      const res = await axiosInstance.post(`/projects/qcchecklist`, updatedData);

      if (res?.data?.id) {
        const response = await axiosInstance.post(
          checklistView === "ITR Checklist"
            ? `projects/mapping_checklist?checklist_id=${res?.data?.id}&checklist_type=${views === "structures" ? "structure" : views}&itr=True`
            : `projects/mapping_checklist?checklist_id=${res?.data?.id}&checklist_type=${views === "structures" ? "structure" : views}&all=True`
        );

        setSnackbarMessage(response?.data?.message || "Checklist saved successfully");
        await setChecklist("");
        await setType();
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
      }
    } catch (err) {
      console.error(err);
      setSnackbarMessage("Something went wrong while saving the checklist");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoader(false);
      setIsEdit(false);
    }
  };


  const handleSaveIndividual = async () => {
    const isValid = validateFields();
    const views = getView(value)

    if (!isValid) {
      return;
    }

    setLoader(true);

    const result = {};
    result["checkpoints"] = checkpoints?.[views];
    result["custom_inputs"] = customFields?.[views];
    result["name"] = "";

    if (listData?.[views]?.id) {
      result["id"] = listData?.[views]?.id;
    }

    const updatedData = {
      ...result,
    };

    setSaveBtnLoader(true)
    try {

      await axiosInstance.post(`/projects/update_tracker_type_map_type?map_type=${view === "Individual" ? 1 : 0}&tracker_type_id=${views === "piers" ? selectedPier?.[0]?.pier_part_tracker_type_id : selectedTt?.[0]?.tracker_type_id}&checklist_type=${views === "structures" ? "structure" : views}`)

      const res = await axiosInstance.post(`/projects/qcchecklist`, updatedData);
      if (res?.data?.id) {
        if(view !== "Individual") {
          const response = await axiosInstance.post(
            getView(value) === "piers" ?
              `/projects/mapping_checklist?checklist_id=${res?.data?.id}&checklist_type=${views === "structures" ? "structure" : views}&tracker_type_id=${views === "piers" ? selectedPier?.[0]?.tracker_type_id : selectedTt?.[0]?.tracker_type_id}` :
              `/projects/mapping_checklist?checklist_id=${res?.data?.id}&checklist_type=${views === "structures" ? "structure" : views}&tracker_type_id=${views === "piers" ? selectedPier?.[0]?.tracker_type_id : selectedTt?.[0]?.tracker_type_id}`
          )
          setSnackbarMessage(response?.data?.message || "Checklist saved successfully");
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
          await setChecklist('')
          await setType()
        } else {
          const response = await axiosInstance.post(
            getView(value) === "piers" ?
              `/projects/mapping_checklist?checklist_id=${res?.data?.id}&checklist_type=${views === "structures" ? "structure" : views}&tracker_type_id=${views === "piers" ? selectedPier?.[0]?.tracker_type_id : selectedTt?.[0]?.tracker_type_id}&pier_part_id=${selectedPier?.[0]?.pier_type_id}` :
              `/projects/mapping_checklist?checklist_id=${res?.data?.id}&checklist_type=${views === "structures" ? "structure" : views}&tracker_type_id=${views === "piers" ? selectedPier?.[0]?.tracker_type_id : selectedTt?.[0]?.tracker_type_id}&tt_part_id=${selectedTt?.[0]?.tt_type_id}`
          )
          setSnackbarMessage(response?.data?.message || "Checklist saved successfully");
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
          await setChecklist('')
          await setType()
        }
      }

    } catch (err) {
      console.error(err);
      setSnackbarMessage("Something went wrong while saving the checklist");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setSaveBtnLoader(false)
      setIsEdit(false)
    }
  }

  const handleSaveAll = async () => {
    const isValid = validateFields();
    const views = getView(value)

    // If validation fails, exit early and don't proceed
    if (!isValid) {
      return;
    }


    setLoader(true);

    const result = {};
    result["checkpoints"] = checkpoints?.[views];
    result["custom_inputs"] = customFields?.[views];
    result["name"] = "";

    if (listData?.[views]?.id) {
      result["id"] = listData?.[views]?.id;
    }

    const updatedData = {
      ...result,
    };

    setButtonLoader(true)
    try {
      await axiosInstance.post(`/projects/update_tracker_type_map_type?map_type=${view === "Individual" ? 1 : 0}&tracker_type_id=${views === "piers" ? selectedPier?.[0]?.tracker_type_id : selectedTt?.[0]?.tracker_type_id}&checklist_type=${views === "structures" ? "structure" : views}`)


      const res = await axiosInstance.post(`/projects/qcchecklist`, updatedData);
      if (res?.data?.id) {
        const response = await axiosInstance.post(`/projects/mapping_checklist?checklist_id=${res?.data?.id}&checklist_type=${views === "structures" ? "structure" : views}&tracker_type_id=${views === "piers" ? selectedPier?.[0]?.tracker_type_id : selectedTt?.[0]?.tracker_type_id}&all=true`);
        setSnackbarMessage(response?.data?.message || "Checklist saved successfully");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        await setChecklist('')
        await setType()
      }

    } catch (err) {
      console.error(err);
      setSnackbarMessage("Something went wrong while saving the checklist");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setButtonLoader(false)
      setIsEdit(false)
    }
  }

  function flattenTrackerData(data) {
    if (!data || typeof data !== 'object') return { table_coordinates: [], piers: [], tt: [] };

    const tableCoords = data.table_coordinates ?? {};
    const piers = data.piers ?? {};
    const tt = data.tt ?? {};

    const trackerId = Object.keys(tableCoords)?.[0];

    if (!trackerId) {
      return { table_coordinates: [], piers: [], tt: [] };
    }

    return {
      table_coordinates: tableCoords[trackerId] ?? [],
      piers: piers[trackerId] ?? [],
      tt: tt[trackerId] ?? []
    };
  }
function flatNextTrackerData(data) {
    if (!data || typeof data !== 'object') return { piers: [], tt: [] };

    const piers = data.piers ?? {};
    const tt = data.tt ?? {};

    const trackerId = Object.keys(piers)?.[0];

    if (!trackerId) {
      return { piers: [], tt: [] };
    }

    return {
      piers: piers[trackerId] ?? [],
      tt: tt[trackerId] ?? []
    };
  }

  const handleClickTorquetube = (key) => {
    if(getView(value) !== "piers") {
      setSelectedTt([key])
    }
  }

  const handleClickPier = (key) => {
    if(getView(value) === "piers") {
      setSelectedPier([key])
    }
  }

  useEffect(() => {
    if(view === "Individual" && active !== "checklist") {
        if(getView(value) === "piers" && (flatNextTrackerData(SvgData)?.tt?.length || flatNextTrackerData(SvgData)?.piers?.length)) {
          setSelectedPier([flatNextTrackerData(SvgData)?.piers?.[0]])
          setSelectedTt([])
        } else {
          setSelectedTt([flatNextTrackerData(SvgData)?.tt?.[0]])
          setSelectedPier([])
        }
    } else {
      if(getView(value) === "piers" && (flatNextTrackerData(SvgData)?.tt?.length || flatNextTrackerData(SvgData)?.piers?.length)) {
        setSelectedPier(flatNextTrackerData(SvgData)?.piers)
        setSelectedTt([])
      } else {
        setSelectedTt(flatNextTrackerData(SvgData)?.tt)
        setSelectedPier([])
      }
    }
    // eslint-disable-next-line
  }, [active, SvgData, view, value])


  return (
    <>
      <Box px={4} py={2}>
        <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" mb={2}>
          {active === "checklist" ? "" : (
            <Typography fontSize={20} fontWeight={600}>
              {active}
            </Typography>
          )}
          <Box>
            <ToggleButtonComponent
              data={active === "checklist" ? ["Template Checklist", "ITR Checklist"] : ["Combined", "Individual"]}
              active={active === "checklist" ? checklistView : view}
              setActive={active === "checklist" ? setChecklistView : setView}
              isEdit={isEdit}
              current={"QC"}
            />
          </Box>
          <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
            {(active === "checklist" && checklistView === "ITR Checklist") && (
              <Tooltip
                title={"Note - This will be set as ITR Checklist"}
                placement="bottom"
                componentsProps={{
                  tooltip: {
                    sx: {
                      bgcolor: "white",
                      color: "black",
                      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
                      maxWidth: 300,
                      fontSize: "14px",
                      p: 1,
                      cursor: "pointer"
                    }
                  }
                }}
              >
                <InfoOutlined fontSize="small" sx={{ color: "#9ca3af" }} />
              </Tooltip>
            )}
            {isEdit ? (
              <Box display="flex" gap={2}>
                {active !== "checklist" && (
                  <Button variant="contained" disabled={view === "Combined"} loading={btnLoader} onClick={handleSaveAll}>
                    Save and Apply to all {getView(value) === "piers" ? getView(value) : "Bays"} in this {toLower(startCase(TERMS.TRACKER_LABEL))} type
                  </Button>
                )}
                {active !== "checklist" && (
                  <Button variant="contained" loading={saveBtnLoader} onClick={handleSaveIndividual}>
                    Save
                  </Button>
                )}
                {active === "checklist" && (
                  <Button variant="contained" loading={loader} onClick={handleSave}>
                    Save and Apply to all {getView(value)} across all {toLower(startCase(TERMS.TRACKER_LABEL))} types
                  </Button>)}
                <Button variant="outlined" onClick={() => setIsEdit(false)}>
                  Cancel
                </Button>
              </Box>
            ) : (
              <Button variant="contained" onClick={() => setIsEdit(true)} disabled ={isReadOnly()}>
                Edit
              </Button>
            )}
          </Box>
        </Box>

        {(tabLoader) ? (
        <Box
          sx={{
            height: "calc(100vh - 260px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ display: "flex", gap: 0.5, width: "100%", flexDirection: "column" }}>
         {active !== "checklist" &&  
            <Box sx={{ width: "100%", bgcolor: isEdit ? '#f5f5f5b8' : '#f3f4f6' }}>
                {currentProject?.type === 1 ?
                 <IndividualZimmerBlock
                    tableCoordinates={flattenTrackerData(SvgData)?.table_coordinates}
                    data={flattenTrackerData(SvgData)}
                    view={view}
                    current={getView(value)}
                    mapType={view === "Combined" ? 0 : 1}
                    selectedTt={selectedTt}
                    setSelectedTt={setSelectedTt}
                    selectedPier={selectedPier}
                    setSelectedPier={setSelectedPier}
                    active={active}
                    handleClickPier={handleClickPier}
                    handleClickBay={handleClickTorquetube}

                /> :
                <IndividualTrackerRow
                    pierlegends = {pierLegends} 
                    data={flatNextTrackerData(SvgData)}
                    selectedTt={selectedTt}
                    setSelectedTt={setSelectedTt} 
                    selectedPier={selectedPier} 
                    setSelectedPier={setSelectedPier}
                    type={"qc"}
                    view={view}
                    current={getView(value)}
                    tabLoader={tabLoader}
                    handleClickPier={handleClickPier}
                    handleClickTorquetube={handleClickTorquetube}
                 />}
            </Box>}
            <Box sx={{  width: "100%" }}>
                <TabComponent
                    customFields={customFields}
                    setCustomFields={setCustomFields}
                    setCheckpoints={setCheckpoints}
                    checkpoints={checkpoints}
                    isEdit={isEdit}
                    value={value}
                    setValue={setValue}
                    loading={loading}
                    tabLoader={tabLoader}
                    selectedPier={selectedPier}
                    selectedTt={selectedTt}
                    active={active}
                    errors={errors} 
                    setErrors={setErrors}
                    currentProject={currentProject}
                    // currentProject={currentProject}
                />
            </Box>

          </Box>)}
      </Box>

      {/* Snackbar for API messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} sx={{ width: "100%" }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ParentComponent;
